const SectionHeader = ({ icon, title }) => (
  <div className="flex items-center gap-4 mt-[1.5rem] mb-[0.5rem]">
    {icon}
    <span className="text-md font-semibold">{title}</span>
  </div>
);
export default SectionHeader